import names from '@/constants/names'

const pageMethods = {
  computed: {
    nameActivePage () {
      return this.$route.name || ''
    },
    nameActivePageForMethod () {
      return names.activePage?.[this.nameActivePage] || this.nameActivePage
    },
    getPageTitle () {
      return names.pageNames?.[this.nameActivePageForMethod] || ''
    }
  }
}

export default pageMethods